// extracted by mini-css-extract-plugin
module.exports =  {"horizontal-group":"_35875ce240--horizontal-group--o1T8f","vertical-group":"_35875ce240--vertical-group--kz0pR"};